<!-- 登录页面 -->
<template>
    <div :style="'height:' + innerHeight + 'px;'">
        <div class="bg"></div>
        <div class="card-div">
            <div class="card">
                <Tabs value="1" @on-click="changeStatus">
                    <TabPane label="账号登录" name="1">
                        <Form ref="formInline" :model="formInline" :rules="ruleInline">
                            <FormItem prop="account">
                                <div class="mb-12 position_relative">
                                    <Input class="width_100" type="text" v-model="formInline.account" placeholder="用户名"/>
                                    <Icon class="form_icon" size="20" type="md-person" color="#999"></Icon>
                                </div>
                            </FormItem>
                            <FormItem prop="pwd">
                                <div class="mb-12 position_relative">
                                    <Input class="width_100" type="password" v-model="formInline.pwd" placeholder="账户密码"/>
                                    <Icon class="form_icon" size="20" type="md-unlock" color="#999"></Icon>
                                </div>
                            </FormItem>
                            <FormItem>
                                <Button @click="handleSubmit">点 击 登 录</Button>
                            </FormItem>
                        </Form>
                    </TabPane>
                    <TabPane label="手机号注册" name="2">
                        <Form ref="formInline" :model="formInline" :rules="ruleInlineCode">
                            <FormItem prop="phone">
                                <div class="mb-12 position_relative">
                                    <Input class="width_100" type="text" v-model="formInline.phone" placeholder="手机号"/>
                                    <Icon class="form_icon" size="20" type="md-phone-portrait" color="#999"></Icon>
                                </div>
                            </FormItem>
                            <FormItem prop="code">
                                <div class="mb-12 position_relative">
                                    <Input :disabled="code_value == 1 ? true : false" class="width_100" type="text" v-model="formInline.code" placeholder="验证码"/>
                                    <Icon class="form_icon" size="20" type="md-checkbox" color="#999"></Icon>
                                    <div v-if="code_value == 1" class="form-code" @click="getCode">获取验证码</div>
                                    <div v-else-if="code_value == 2" class="form-code-active">已发送</div>
                                    <div v-else-if="code_value == 3" class="form-code-active">{{time_value}}S</div>
                                    <div v-else-if="code_value == 4" class="form-code" @click="getCode">重发验证码</div>
                                </div>
                            </FormItem>
                            <FormItem>
                                <Button @click="handleSubmit">点 击 注 册</Button>
                            </FormItem>
                        </Form>
                    </TabPane>
                </Tabs>
            </div>
        </div>
    </div>
</template>
<script>
import { 
    login,
    tokens,
    login_yzm,
    yzm_login,
} from "@/api/index";
import { windowsRise } from "@/utils/dom";
import { setCookies } from "@/utils/helper";
export default {
    data() {
        return {
            innerHeight: 0,
            formInline: {
                account: "",
                pwd: "",
                phone: "",
                code: "",
            },
            ruleInline: {
                account: [
                    {
                        required: true,
                        message: "用户名不能为空",
                        trigger: "blur",
                    },
                ],
                pwd: [
                    {
                        required: true,
                        message: "账户密码不能为空",
                        trigger: "blur",
                    },
                ],
            },
            ruleInlineCode: {
                phone: [
                    {
                        required: true,
                        message: "手机号不能为空",
                        trigger: "blur",
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('手机号不能为空'));
                            } else if (!/^1[3-9]\d{9}$/.test(value)) {
                                callback(new Error('请输入正确的11位手机号码'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur',
                    },
                ],
                code: [
                    {
                        required: true,
                        message: "验证码不能为空",
                        trigger: "blur",
                    },
                ],
            },
            code_value: 1,
            timer: null, // 定时器
            time_value: '60',
            status_value: 1, //短信登录
        };
    },
    beforeDestroy() {
        // 清除定时器
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
    mounted() {
        this.restHeight();
        windowsRise(window, this.restHeight);
        let hashPart = window.location.hash;
        let queryString = hashPart.replace(/^#\/\?/, "?");
        let params = new URLSearchParams(queryString);
        let tokenValue = params.get("token");
        console.log(tokenValue);
        if (tokenValue) {
            console.log("token登录");
            tokens({ token: tokenValue }).then((res) => {
                this.$Message.success(res.msg);
                setCookies("pcToken", res.data.token);
                localStorage.setItem("user", res.data.account);
                localStorage.setItem("phone", res.data.phone);
                localStorage.setItem("id", res.data.id);
                localStorage.setItem("admin_id", res.data.admin_id);
                localStorage.setItem("app_ids", res.data.app_ids);
                localStorage.setItem("IDENTITYS", res.data.identitys);
                this.$store.commit("setMenus", res.data.menu);
                localStorage.setItem("demo_file_path", res.data.demo_file_path);
                localStorage.setItem("tips_path", res.data.tips_path);
                localStorage.setItem("tips_link", res.data.tips_link);
                this.$router.push({ path: "/admin" });
            })
            .catch((res) => {
                this.$Message.error(res.msg);
            });
        }
    },
    created() {
        var _this = this;
        document.onkeydown = function () {
            if (_this.$route.name === "登录") {
                let key = window.event.keyCode;
                if (key === 13) {
                    _this.handleSubmit();
                }
            }
        };
    },
    methods: {
        restHeight() {
            this.innerHeight = window.innerHeight - 2;
        },
        handleSubmit() {
            if(this.status_value == 1){
                if(this.formInline.account && this.formInline.pwd){
                    var data = {
                        account: this.formInline.account,
                        pwd: this.formInline.pwd
                    }
                }else{
                    this.$Message.error("数据不能为空");
                    return
                }
                login(data).then((res) => {
                    this.$Message.success(res.msg);
                    setCookies("pcToken", res.data.token);
                    localStorage.setItem("user", res.data.account);
                    localStorage.setItem("phone", res.data.phone);
                    localStorage.setItem("id", res.data.id);
                    localStorage.setItem("admin_id", res.data.admin_id);
                    localStorage.setItem("app_ids", res.data.app_ids);
                    localStorage.setItem("IDENTITYS", res.data.identitys);
                    this.$store.commit("setMenus", res.data.menu);
                    localStorage.setItem("demo_file_path", res.data.demo_file_path);
                    localStorage.setItem("tips_path", res.data.tips_path);
                    localStorage.setItem("tips_link", res.data.tips_link);
                    this.$router.push({ path: "/admin" });
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
            }else{
                if(this.formInline.phone && this.formInline.code){
                    var data = {
                        phone: this.formInline.phone,
                        code: this.formInline.code
                    }
                }else{
                    this.$Message.error("数据不能为空");
                    return
                }
                yzm_login(data).then((res) => {
                    this.$Message.success(res.msg);
                    setCookies("pcToken", res.data.token);
                    localStorage.setItem("user", res.data.account);
                    localStorage.setItem("phone", res.data.phone);
                    localStorage.setItem("id", res.data.id);
                    localStorage.setItem("admin_id", res.data.admin_id);
                    localStorage.setItem("app_ids", res.data.app_ids);
                    localStorage.setItem("IDENTITYS", res.data.identitys);
                    this.$store.commit("setMenus", res.data.menu);
                    localStorage.setItem("demo_file_path", res.data.demo_file_path);
                    localStorage.setItem("tips_path", res.data.tips_path);
                    localStorage.setItem("tips_link", res.data.tips_link);
                    this.$router.push({ path: "/admin" });
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
            }
        },
        getCode(){
            const phoneReg = /^1[3-9]\d{9}$/
            if (!this.formInline.phone) {
                this.$Message.error("手机号不能为空");
                return;
            } else if (!phoneReg.test(this.formInline.phone)) {
                this.$Message.error("手机号格式不正确");
                return;
            }
            login_yzm({phone: this.formInline.phone}).then((res) => {
                this.$Message.success(res.msg);
            })
            .catch((res) => {
                this.$Message.error(res.msg);
            });
            this.code_value = 2
            setTimeout(() => {
                this.code_value = 3;
            }, 1000);
            // 开始倒计时
            this.time_value = 60;
            this.timer = setInterval(() => {
                if (this.time_value > 1) {
                    this.time_value--;
                } else {
                    clearInterval(this.timer);
                    this.code_value = 4;
                }
            }, 1000);
        },
        changeStatus(e){
            this.status_value = e
        },
    },
};
</script>
<style scoped>
.bg {
    background: url("../../assets/login_bg.png") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
}
.card-div {
    margin: 0 0 0 20vw;
    width: 333px;
    height: 100%;
    position: absolute;
    z-index: 999;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.card {
    border: 1px solid #f8b283;
    padding: 24px;
    border-radius: 10px;
}
.title {
    margin: 0 0 24px 0;
    font-weight: 600;
    font-size: 30px;
    color: #ff761d;
}
::v-deep .ivu-input {
    padding: 0 0 0 33px;
    height: 40px;
    background: #ffffff;
    border-radius: 25px;
    border: 1px solid #ccc;
    font-size: 16px;
}
::v-deep .ivu-btn {
    width: 100%;
    height: 40px;
    background: linear-gradient(90deg, #ff822e 0%, #ffa451 100%);
    border-radius: 25px;
    font-size: 16px;
    color: #ffffff;
}
.position_relative {
    position: relative;
}
.width_100 {
    width: 100%;
}
.form_icon {
    width: 20px;
    height: 20px;
    position: absolute;
    left: 10px;
    z-index: 999;
    top: 10px;
}
.form-code {
    position: absolute;
    right: 12px;
    top: 5px;
    z-index: 999;
    color: #ff761d;
    font-size: 12px;
    cursor: pointer;
}
.form-code-active {
    position: absolute;
    right: 12px;
    top: 5px;
    z-index: 999;
    color: #808080;
    font-size: 13px;
    cursor: pointer;
}
::v-deep .ivu-tabs-tab:hover {
    color: #ff761d;
}
::v-deep .ivu-tabs-nav .ivu-tabs-tab-active {
    color: #ff761d;
    font-size: 16px;
}
::v-deep .ivu-tabs-tab {
    font-size: 16px;
}
::v-deep .ivu-tabs-ink-bar {
    background-color: #ff761d !important;
    width: 55px !important;
    left: 19px !important;
}
::v-deep .ivu-tabs-bar {
    border-bottom: none;
    margin-bottom: 33px;
}
::v-deep .ivu-tabs-nav-scroll {
    display: flex;
    align-items: center;
    justify-content: center;
}
::v-deep .ivu-form-item {
    margin-bottom: 12px;
}
</style>